<script>
  import { Button, Icon } from "sveltestrap";
  import Croquis from "../../../Croquis.svelte";
  import { clearCanvas } from "../../../../utils/croquis";

  let avatar = null, fileinput;

  const onFileSelected = (e) => {
    let image = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = (e) => {
      avatar = e.target.result;
      document.getElementById("main").style.overflowY = "auto";
    };
  };
</script>


<div class="row">
  <div class="col-md-12">
    <div class="row mb-3 ">
      <div class="col-12 col-md-2 mr-5 mt-2 mb-3">
        {#if avatar}
          <img class="avatar mt-5" src={avatar} alt="avatar" width="100%" />
        {:else}
          <img
            class="avatar mt-5"
            src="https://static.vecteezy.com/system/resources/thumbnails/000/350/939/small/Electronic_Devices__2828_29.jpg"
            alt=""
            width="100%"
          />
        {/if}
        <Button
          style="width:100%"
          class="chan"
          on:click={() => {
            fileinput.click();
          }}
        >
          <Icon name="upload" />
        </Button>
        <Button
          style="width:100%"
          class="mt-1"
          on:click={() => {
            if (avatar != null) {
              fileinput.value = "";
              avatar = null;
            } else {
              clearCanvas();
            }
          }}
        >
          Limpiar
        </Button>
        <input
          style="display:none"
          type="file"
          accept=".jpg, .jpeg, .png"
          on:change={(e) => onFileSelected(e)}
          bind:this={fileinput}
        />
      </div>
      <div class="col-12 col-md-8 text-center mt-2 mb-3">
        {#if avatar}
          <img class="avatar mt-5" src={avatar} alt="avatar" width="100%" />
        {:else}
          <Croquis/>
        {/if}
      </div>
    </div>
  </div>
</div>